import React from 'react';
import { Radio } from '@material-ui/core';

import { StyledRadio } from './styles';

const RadioButton = (props) => (
  <StyledRadio
    {...props}
    control={<Radio size="small" />}
  />
);

export default RadioButton;
